import { useCallback, useState } from 'react';

type UseSidebarCollapseResult = {
  collapsed: boolean;
  toggle: () => void;
};

export function useSidebarCollapse(initialCollapsed = true): UseSidebarCollapseResult {
  const [collapsed, setCollapsed] = useState(initialCollapsed);

  const toggle = useCallback(() => {
    setCollapsed((prev) => !prev);
  }, []);

  return { collapsed, toggle };
}
